module.exports = __webpack_public_path__ + "img/changZuiHu5.f560b88a.png";